import { render, staticRenderFns } from "./StoreHomeVideoSettings.vue?vue&type=template&id=534e03aa&"
import script from "./StoreHomeVideoSettings.vue?vue&type=script&lang=js&"
export * from "./StoreHomeVideoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports